import { Badge, SxProps, Theme, Tooltip } from '@mui/material';
import { Lightning } from '@phosphor-icons/react';
import React from 'react';

const AUTO_TRIGGER_COLOR = '#3650DE';

const badgeSx: SxProps<Theme> = {
  '& .MuiBadge-badge': {
    minWidth: 0,
    width: 13,
    height: 13,
    padding: 0,
    borderRadius: '50%',
    backgroundColor: AUTO_TRIGGER_COLOR,
    color: '#FFFFFF',
    transform: 'scale(1) translate(-60%, 60%)',
    transformOrigin: '0% 100%',
  },
};

interface AutoTriggerBadgeProps {
  active?: boolean;
  children: React.ReactNode;
}

/**
 * Overlays a small Link badge on the bottom-left corner of an agent icon to
 * signal that Auto Trigger is enabled. Renders children untouched when inactive.
 * Shared by the legacy and beta sidebars so the indicator stays consistent.
 */
export const AutoTriggerBadge = ({
  active,
  children,
}: AutoTriggerBadgeProps) => {
  if (!active) {
    return <>{children}</>;
  }
  return (
    <Tooltip title='Auto Trigger enabled'>
      <Badge
        overlap='circular'
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        badgeContent={<Lightning size={9} weight='fill' />}
        sx={badgeSx}
      >
        {children}
      </Badge>
    </Tooltip>
  );
};
